import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import TextureOverlay from '../components/team/TextureOverlay';
import SiteHeader from '../components/team/SiteHeader';
import Footer from '../components/team/Footer';

// Prerendered to build/404.html, which Cloudflare Pages serves with a 404 status.
export default function NotFound() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>Page not found | Mubarak Farm</title>
          <meta name="robots" content="noindex" />
        </Helmet>
      </HelmetProvider>
      <TextureOverlay fixed />
      <SiteHeader />
      <main>
        <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28">
          <div className="container mx-auto px-4 lg:px-8 relative z-10">
            <div className="max-w-6xl mx-auto">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">404</p>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900 mb-6">
                This page does not exist.
              </h1>
              <p className="text-lg text-gray-700 max-w-2xl leading-relaxed mb-10">
                The link may be old or mistyped. You can find our Uganda Robusta and wholesale green bean pricing from the pages below.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a
                  href="/"
                  className="inline-flex items-center justify-center bg-gold-500 hover:bg-gold-400 text-gray-900 font-bold px-8 py-4 rounded-full transition-[background-color,transform] duration-200 active:scale-[0.97]"
                >
                  Go to the home page
                </a>
                <a
                  href="/wholesale"
                  className="inline-flex items-center justify-center bg-gray-900 hover:bg-clay text-white font-bold px-8 py-4 rounded-full transition-[background-color,transform] duration-200 active:scale-[0.97]"
                >
                  See wholesale pricing
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
}
